// prismjs color theme
require('./src/styles/prism.css')
require('./node_modules/bootstrap/dist/js/bootstrap')
require('./node_modules/bootstrap/dist/css/bootstrap.css')
require('katex/dist/katex.min.css')
